<div id="wrap">
    <header class="header">
        <div class="header_inner">
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right">
                <button type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
                <a routerLink="/login" class="btn_join"><b>로그인</b></a>
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
        </div>
    </header>

    <div id="content">
        <div id="skip_anchor" class="content page_signUp">
            <div class="center_title">
                <h2>BUDDY 회원가입</h2>
                <div class="mo_box">
                    <p class="center_title_sub">오아시스마켓 ID를 이용해 회원가입이 가능합니다.</p>
                    <p class="center_title_desc"><span class="col-orange">&#42;</span>필수 입력 항목입니다.</p>
                </div>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>오아시스마켓 ID</label>
                <input type="text" [(ngModel)]="user.userId" (keyup.enter)="checkUserId()" [disabled]="isUserIdCheck" class="form_input" placeholder="오아시스마켓 아이디를 정확히 입력해 주세요."/>
                <button type="button" class="form_button btn_required" (click)="checkUserId()" [disabled]="isUserIdCheck">확인</button>
                <p *ngIf="!isUserIdCheck" class="form_msg">&#8251;아이디를 모르실 경우 핸드폰 번호 인증 시 오아시스마켓 ID를 확인하실 수 있습니다.</p>
            </div>
            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>비밀번호</label>
                <input type="password" [(ngModel)]="user.password" (keyup)="checkPassword()" class="form_input" placeholder="사용하실 비밀번호를 입력해 주세요." autocomplete="new-password"/>
                <p *ngIf="passwdCheckMsg" class="form_msg">{{passwdCheckMsg}}</p>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>비밀번호 확인</label>
                <input type="password" [(ngModel)]="user.passwordConfirm" (keyup)="checkConfirmPassword()" class="form_input" placeholder="사용하실 비밀번호를 한번 더 입력해 주세요."/>
                <p *ngIf="confirmPasswdCheckMsg" class="form_msg">{{confirmPasswdCheckMsg}}</p>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>이름</label>
                <input type="text" [(ngModel)]="user.userName" class="form_input" placeholder="이름을 입력해 주세요."/>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>핸드폰 번호</label>
                <input type="text" [(ngModel)]="user.tel" (keyup.enter)="signUpOtpSend()"  [disabled]="isOtpSend" class="form_input required" placeholder="핸드폰 번호를 입력해 주세요."/>
                <button type="button" class="form_button btn_required" (click)="signUpOtpSend()" [disabled]="isOtpSend">인증번호</button>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>인증번호 입력</label>
                <input type="text" [(ngModel)]="user.otpCode" (keyup.enter)="signUpOtpCheck()" [disabled]="isOtpConfirmTry && isOtpSend" class="form_input required" placeholder="인증번호를 입력해 주세요." />
                <span *ngIf="isOtpSend || isOtpConfirmTry" class="form_timer">{{displayTime}}</span>
                <button type="button" class="form_button btn_required" (click)="signUpOtpCheck()" [disabled]="!isOtpSend || isOtpConfirm">확인</button>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>E-mail</label>
                <input type="text" [(ngModel)]="user.email" class="form_input" placeholder="E-mail 주소를 입력해 주세요."/>
            </div>

            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>예금주</label>
                <input type="text" class="form_input" [(ngModel)]="depositor" placeholder="예금주를 입력해 주세요."/>
            </div>
            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>계좌정보</label>
                <select class="select_current" [(ngModel)]="bankCode">
                    <option value="">::은행선택::</option>
                    <option *ngFor="let item of bankCodeList" [value]="item.code" [innerHTML]="item.codeName"></option>
                </select>
                <input type="text" class="form_input" [(ngModel)]="accountNumber" placeholder="수익금 입금이 가능한 계좌번호를 입력해 주세요."/>
            </div>
            <div class="form">
                <label class="form_label"><span class="asterisk">&#42;</span>통장사본</label>
                <input type="text" id="accountFile" class="form_input" placeholder="통장사본을 첨부해 주세요." readonly [(ngModel)]="accountFileName" />
                <input type="file" id="controlFiles" name="controlFiles" class="blind" (change)="onFileChange1(fileInput1.files, $event.target)" #fileInput1/>
                <label for="controlFiles" class="form_button btn_required">파일 찾기</label>
            </div>
            <div class="form">
                <label class="form_label">추천인 정보</label>
                <input type="text" [(ngModel)]="recommendUserId" [disabled]="isRecommendUserCheck" class="form_input" placeholder="추천인의 오아시스버디 아이디를 입력해 주세요."/>
                <button type="button" (click)="getRecommendUserNo()" [disabled]="isRecommendUserCheck" class="form_button btn_required">확인</button>
            </div>

            <div class="form">
                <label for="businessType" class="form_label"><span class="asterisk">&#42;</span>사업자 유형</label>
                <div class="form_group div-2">
                    <div class="radio">
                        <input type="radio" [(ngModel)]="user.userType" value="UT1" name="businessOperatorType" id="userType-UT1" class="form_radio" />
                        <label for="userType-UT1">개인</label>
                    </div>
                    <div class="radio">
                        <input type="radio" [(ngModel)]="user.userType" value="UT2" name="businessOperatorType" id="userType-UT2" class="form_radio" />
                        <label for="userType-UT2">개인사업자/법인사업자</label>
                    </div>
                </div>
            </div>
            <!--
            <div class="form" *ngIf="user.userType == 'UT2' || user.userType == 'UT3'">
                <strong class="form_label"><span class="asterisk">&#42;</span>세금계산서</strong>
                <div class="form_group div-2">
                    <div class="radio">
                        <input type="radio" [(ngModel)]="user.cashbillYn" value="Y" name="taxBill" id="taxBillY" class="form_radio" />
                        <label for="taxBillY">제공</label>
                    </div>
                    <div class="radio">
                        <input type="radio" [(ngModel)]="user.cashbillYn" value="N" name="taxBill" id="taxBillN" class="form_radio" />
                        <label for="taxBillN">미제공</label>
                    </div>
                </div>
            </div>
            -->


            <div class="form" *ngIf="user.userType == 'UT1'">
                <label class="form_label"><span class="asterisk">&#42;</span>주민등록번호</label>
                <input type="text" [(ngModel)]="regidentNumberPart1" class="form_input" inputmode="numeric" pattern="[0-9]*" maxlength="6" />
                <span class="form_dash">-</span>
                <input type="text" [(ngModel)]="regidentNumberPart2" class="form_input" inputmode="numeric" pattern="[0-9]*" maxlength="7" />
            </div>
            <div class="form" *ngIf="user.userType == 'UT1'">
                <label for="licenseFile" class="form_label"><span class="asterisk">&#42;</span>신분증사본</label>
                <input type="text" id="licenseFile" class="form_input" placeholder="신분증사본을 첨부해 주세요." readonly [(ngModel)]="licenseFileName" />
                <input type="file" id="controlFiles2" name="controlFiles2" class="blind" (change)="onFileChange(fileInput2.files, $event.target)" #fileInput2/>
                <label for="controlFiles2" class="form_button btn_required">파일 찾기</label>
            </div>
            <div class="form" *ngIf="user.userType == 'UT1'">
                <label for="businessType" class="form_label">&nbsp;</label>
                <div class="form_group div-2">
                    ※ "개인"으로 선택시에는 사업소득처리하여 3.3%(원천세)공제 후 지급됩니다.
                </div>
            </div>
            <div class="form" *ngIf="user.userType == 'UT2' || user.userType == 'UT3'">
                <strong class="form_label"><span class="asterisk">&#42;</span>사업자 번호</strong>
                <div class="license_input">
                    <input type="text" [(ngModel)]="corpCodePart1" class="form_input" placeholder="000" maxlength="3" />
                    <span class="dash"></span>
                    <input type="text" [(ngModel)]="corpCodePart2" class="form_input" placeholder="00" maxlength="2" />
                    <span class="dash"></span>
                    <input type="text" [(ngModel)]="corpCodePart3" class="form_input" placeholder="00000" maxlength="5" />
                </div>
            </div>

            <div class="form" *ngIf="user.userType == 'UT2' || user.userType == 'UT3'">
                <label for="attachedFile" class="form_label"><span class="asterisk">&#42;</span>사업자 정보</label>
                <input type="text" id="attachedFile" class="form_input" placeholder="사업자 등록증을 첨부해 주세요." readonly [(ngModel)]="licenseFileName" />
                <input type="file" id="controlFiles2" name="controlFiles2" class="blind" (change)="onFileChange(fileInput2.files, $event.target)" #fileInput2/>
                <label for="controlFiles2" class="form_button btn_required">파일 찾기</label>
            </div>

            <div class="form_inner">
                <strong class="form_inner_title">&#8251;오아시스 버디로 활동하며 관련 링크나 배너를 게시할 본인의 채널 정보를 모두 입력해 주세요. <br /><span class="form_inner_sub">(복수 등록이 가능합니다.)</span></strong>

                <strong class="form_label"><span class="asterisk">&#42;</span>활동채널</strong>
                <div class="form" *ngFor="let item of user.userChannelList">

                    <div class="select">
                        <select class="select_current" [disabled]="item.isOk" [(ngModel)]="item.channelType">
                            <option value="">::선택하세요::</option>
                            <option value="CH01">유튜브</option>
                            <option value="CH02">SNS</option>
                            <option value="CH03">블로그</option>
                            <option value="CH04">카페</option>
                            <option value="CH99">기타</option>
                        </select>
                    </div>
                    <input type="text" class="form_input" [(ngModel)]="item.channelUrl" [disabled]="item.isOk" placeholder="https://"/>
                    <button type="button" *ngIf="!item.isOk" class="form_button btn-success" (click)="addChannel(item)">추가하기</button>
                    <button type="button" *ngIf="item.isOk" class="form_button btn-primary-line" (click)="removeChannel(item)">삭제</button>
                </div>

                <strong class="form_inner_title">&#8251;가입 완료 후 최종 승인을 위하여 활동하시는 채널에 게시된 오아시스 버디 관련 링크, 또는 배너를 확인할 수 있도록 스크린 샷을 등록해 주세요. <span class="form_inner_sub">(마이페이지에서 등록하실 수 있습니다.)</span></strong>
                <div class="form_inner_agree">
                    <p class="form_inner_agree_box">등록되지 않은 채널에서의 광고 활동은 부정행위로 간주될 수 있으며, 이로 인해 불이익을 받으시는 일이 없으시길 바랍니다. 가입 후에도 마이페이지에서 활동채널 링크를 추가하실 수 있습니다.</p>
                    <div class="check">
                        <input type="checkbox" [(ngModel)]="isAgree" id="agreeYn" class="form_check" />
                        <label for="agreeYn">네, 알겠습니다.</label>
                    </div>
                </div>
            </div>

            <div class="form_inner">
              <strong class="form_label" style="padding-top:0"><span class="asterisk">&#42;</span> 약관동의</strong>
                <div class="check">
                    <input type="checkbox" [(ngModel)]="isAgree1" id="agreeYn1" class="form_check" />
                    <label for="agreeYn1">[필수] 개인정보 수집 및 이용동의</label>
                    <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="form_more"><span class="blind">약관 더보기</span></a>
                </div>
                <div class="check">
                    <input type="checkbox" [(ngModel)]="isAgree2" id="agreeYn2" class="form_check" />
                    <label for="agreeYn2">[필수] 대금 지급을 위한 목적으로 개인정보(계좌정보 및 고유식별번호)를 수집 및 이용 동의</label>
                </div>
            </div>

            <div class="btn">
                <a class="btn_cta" (click)="join()">가입하기</a>
            </div>

        </div>
    </div>

    <footer class="footer">
        <app-footer></app-footer>
    </footer>
</div>
